import { audioDeviceStrings } from '../components/audioDeviceStrings';

const TEST_AUDIO_URL =
  'https://contactcenterprod278374.blob.core.windows.net/public-assets/audio/speakertest.mp3';

type HTMLAudioElementWithSinkId = HTMLAudioElement & {
  setSinkId?: (sinkId: string) => Promise<void>;
};

export class AudioPlaybackTestService {
  private audioElement: HTMLAudioElementWithSinkId | null = null;
  private abortCurrentTest: (() => void) | null = null;

  async playSpeakerTest(deviceId: string): Promise<void> {
    this.stopTest();

    const audio: HTMLAudioElementWithSinkId = new Audio(TEST_AUDIO_URL);

    if (typeof audio.setSinkId === 'function') {
      await audio.setSinkId(deviceId);
    }

    this.audioElement = audio;

    return new Promise<void>((resolve, reject) => {
      this.abortCurrentTest = () => {
        reject(new DOMException('Test stopped', 'AbortError'));
      };

      audio.addEventListener('ended', () => {
        this.abortCurrentTest = null;
        this.cleanup();
        resolve();
      });

      audio.addEventListener('error', () => {
        this.abortCurrentTest = null;
        const message =
          audio.error?.message ??
          audioDeviceStrings.errors.unknownPlaybackError;
        this.cleanup();
        reject(new Error(message));
      });

      audio.play().catch((err: Error) => {
        this.abortCurrentTest = null;
        this.cleanup();
        reject(err);
      });
    });
  }

  stopTest(): void {
    if (!this.audioElement) {
      return;
    }
    this.audioElement.pause();
    const abort = this.abortCurrentTest;
    this.abortCurrentTest = null;
    abort?.();
    this.cleanup();
  }

  private cleanup(): void {
    if (this.audioElement) {
      this.audioElement.src = '';
      this.audioElement = null;
    }
  }
}

export const speakerTestService = new AudioPlaybackTestService();
export const ringTestService = new AudioPlaybackTestService();
